<template>
<div>
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <base-material-card color="primary" icon="library_books" title="Administrar Sellos Digitales" class="elevation-1 px-5 py-3" >
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12>

                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        
                        <v-tab :key="'gastos'" >Sellos de la Agencia Aduanal</v-tab>
                        <v-tab :key="'facturas'" >Sellos de Clientes</v-tab>
                        
                        <v-tab-item :key="'patente'" >
                            <patente ref="patente" ></patente>
                        </v-tab-item>
                        <v-tab-item :key="'cliente'" >
                            <cliente ref="cliente" ></cliente>
                        </v-tab-item>
                    </v-tabs>

                </v-flex>
            </v-layout>
        </v-container>
    </base-material-card>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

import cliente from "@/views/clientes/CertificadosAgente";
import patente from "@/views/clientes/CertificadosPatenteAgente";

export default {
    name: "DashboardDashboard",
    watch: {

    },
    components: {
        cliente,
        patente
    },
    data() {
        return {

            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Sellos Digitales",
                    disabled: true,
                    to: ""
                }
            ],

        };
    },

};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
</style>
